// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1O5k2","info":"Note_info__1w8y9","note":"Note_note__1GmtV","actions":"Note_actions__1AphV"};